import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import './i18n' // Initialize i18n
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/fonts.css' // Local Chinese fonts
import './styles/variables.css'
import './styles/animations.css'
import './styles/theme.css'
import './styles/App.css'

// Remove loading screen when React is ready
const removeLoadingScreen = () => {
  const loadingScreen = document.getElementById('loading-screen')
  if (loadingScreen) {
    loadingScreen.classList.add('hidden')
    setTimeout(() => {
      loadingScreen.remove()
    }, 500)
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)

// Remove loading screen after React mounts
removeLoadingScreen()
